import React, { FC } from "react";
import { Typography } from "@mui/material";
import { COPY } from "../../shared/containers/CustomerSupportContainers/constants";

const SupportInfoBanner: FC = () => (
  <div className="w-full rounded-xl bg-turquoise-1 border border-turquoise-border px-4 py-3">
    <Typography sx={{ fontSize: "12px", lineHeight: "18px" }} className="text-promo-turquoise">
      {COPY.INFO_BANNER}
    </Typography>
  </div>
);

export default SupportInfoBanner;
